module.exports = __webpack_public_path__ + "static/media/spongebob-patrick-star.9eee1025.gif";